import ViewportActionTypes from 'app/viewport/ActionTypes';
import reducer from 'app/viewport/reducer';

export default {
  reducers: {
    viewport: reducer,
  },
  actionTypes: ViewportActionTypes,
};
